import React from 'react';
import PropTypes from 'prop-types';
import { Button, makeStyles, Modal } from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";
import AlertIcon from "../../assets/images/alert.svg";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
    transactionModal: {
        position: 'absolute',
        width: 400,
        backgroundColor: theme.palette.background.paper,
        border: 0,
        boxShadow: theme.shadows[5],
        padding: '40px 30px',
        borderRadius: 8,
        outline: 'none',
        '@media (max-width: 767px)': {
            width: '100%',
            padding: '40px 20px 20px',
            borderRadius: 0,
        },
    },
    crossIcon: {
        position: 'absolute',
        right: 10,
        top: 10,
        cursor: 'pointer',
        color: '#757575'
    },
    topHeader: {
        display: 'flex',
        alignItems: 'flex-start',
        '& img': {
            iwtdh: 30,
            marginRight: 20,
        },
        '& h2': {
            paddingBottom: 5,
            color: '#212B36',
            margin: 0,
            fontSize: 18,
        },
        '& p': {
            margin: 0,
            color: '#989898',
            fontSize: 12,
        }
    },
    midContent: {
        margin: '20px 0',
    },
    days: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingBottom: 7,
        '& h4': {
            fontSize: 16,
            margin: 0,
            color: '#4F4F4F',
            fontWeight: 700,
            flex: 1,
            '&.rightAlign': {
                textAlign: 'right'
            },
            '@media (max-width: 767px)': {
                fontSize: 14,
            },
        }
    },
    discountedPrice: {
        color: '#757575',
        fontWeight: 400,
        fontSize: 13,
        position: 'relative',
        marginRight: 5,
        '&::before': {
            content: `''`,
            position: 'absolute',
            zIndex: 1,
            background: '#757575',
            height: 2,
            width: '100%',
            top: 6
        }
    },
    expired: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '& p': {
            fontSize: 12,
            margin: 0,
            color: '#4F4F4F',
            flex: 1,
            fontWeight: 700,
            '&.green': {
                color: '#40B90E',
                textAlign: 'right',
                fontWeight: 700,
            }
        }
    },
    retryBtns: {
        '& button': {
            width: '100%',
            marginBottom: 10,
            borderRadius: 0,
            backgroundColor: '#008C74',
            padding: 9,
            color: '#fff',
            fontSize: 16,
            fontWeight: 'bold',
            border: '1px solid #008C74',
            textTransform: 'capitalize',
            '&:hover': {
                backgroundColor: '#008C74',
            }
        }
    },
    contactUsBtn: {
        backgroundColor: '#fff !important',
        color: '#008C74 !important',
        border: '1px solid #008C74',
        '&:hover': {
            backgroundColor: '#fff !important',
        }
    },
    failedTransactionModal: {
        alignItems: 'flex-end !important',
        '@media (min-width: 768px)': {
            alignItems: 'center !important',
        }
    },
    couponModal: {
        zIndex: '9999 !important',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }
}));
const FailedTransactionModel = props => {
    const classes = useStyles();
    const navigate = useNavigate();
    const { isOpen, closeModel, transactionDetails, getDays } = props;
    const plan = transactionDetails && transactionDetails && transactionDetails.plan ? transactionDetails.plan : {};

    function retryPayment() {
        navigate('/my-app/payments');
    }

    const failedTransactionBody = (
        <div className={`${classes.transactionModal}`}>
            <span onClick={closeModel} className={classes.crossIcon}>
                <ClearIcon/>
            </span>
            <div className={classes.topHeader}>
                <img src={AlertIcon} alt=""/>
                <div>
                    <h2>Transaction Failed</h2>
                    <p>Don't worry! Any deducted amount will be refunded within 5 - 7 business days.</p>
                </div>
            </div>
            <div className={classes.midContent}>
                <div className={classes.days}>
                    <h4>{plan.name}</h4>
                    <h4 className="rightAlign"><span
                        className={classes.discountedPrice}>₹{plan.actualPrice}</span> ₹{plan.price}</h4>
                </div>
                <div className={classes.expired}>
                    <p>Valid for {getDays(plan.subscriptionType)} Days</p>
                    <p className="green">You Save <span>₹{(plan.actualPrice - plan.price).toFixed(2)} ({plan.discount}%)</span></p>
                </div>
            </div>
            <div className={classes.retryBtns}>
                <Button onClick={retryPayment}>Retry Payment</Button>
                {/*<Button className={classes.contactUsBtn}>Talk To Us</Button>*/}
            </div>
        </div>
    );
    return (
        <Modal
            open={isOpen}
            onClose={closeModel}
            className={`${classes.failedTransactionModal} ${classes.couponModal}`}
        >
            {failedTransactionBody}
        </Modal>
    );
};

FailedTransactionModel.propTypes = {
    isOpen: PropTypes.bool,
    closeModel: PropTypes.func
};
export default FailedTransactionModel;
